module.exports = __webpack_public_path__ + "static/media/institut-francais-deutschland-logo.cf8bebd2.svg";